import {
	type NodeViewComponentProps,
	useEditorEventCallback,
} from "@handlewithcare/react-prosemirror";
import { forwardRef, useRef, useState } from "react";

import { Toolbar, ToolbarItem } from "@moment/design-system";

export const Columns = forwardRef<HTMLElement, NodeViewComponentProps>(function Columns(
	{ nodeProps, children, ...props },
	ref
) {
	const { node, getPos } = nodeProps;
	const numCols = node.attrs["columns"];
	const [showControls, setShowControls] = useState(false);
	const toolbarWrapperRef = useRef<HTMLDivElement | null>(null);

	const onToolbarItemClick = useEditorEventCallback((view, columns) => {
		view.dispatch(view.state.tr.setNodeAttribute(getPos(), "columns", columns));
		view.focus();
	});

	return (
		<>
			{showControls && (
				<div
					contentEditable="false"
					ref={toolbarWrapperRef}
					className="absolute -translate-y-full left-[var(--default-padding)]"
				>
					<Toolbar>
						<ToolbarItem
							label="Two"
							isActive={numCols === 2}
							onClick={() => {
								onToolbarItemClick(2);
							}}
						>
							2
						</ToolbarItem>
						<ToolbarItem
							label="Three"
							isActive={numCols === 3}
							onClick={() => {
								onToolbarItemClick(3);
							}}
						>
							3
						</ToolbarItem>
						<ToolbarItem
							label="Four"
							isActive={numCols === 4}
							onClick={() => {
								onToolbarItemClick(4);
							}}
						>
							4
						</ToolbarItem>
					</Toolbar>
				</div>
			)}
			<section
				ref={ref}
				{...props}
				data-node-type="columns"
				data-columns={numCols}
				style={{ columns: numCols }}
				onMouseEnter={() => {
					setShowControls(true);
				}}
				onMouseLeave={(e) => {
					if (
						e.relatedTarget instanceof HTMLElement &&
						toolbarWrapperRef.current?.contains(e.relatedTarget)
					) {
						return;
					}
					setShowControls(false);
				}}
			>
				{children}
			</section>
		</>
	);
});
